module.exports = __webpack_public_path__ + "img/CadRequestJP.b5b14975.png";